import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bloomingtonILConfig } from "./data";

export default function BloomingtonILPage() {
  return <CityPageTemplate config={bloomingtonILConfig} />;
}